import { useForm } from "react-hook-form";
import { useAxiosInstance } from "../../services/Interceptor";
import { useNavigate } from "react-router-dom";
import { sendResetPasswordEmail } from "../../services/ContactPublicService";
import Nav from "../../components/Nav";
import { toast } from "react-toastify";

export default function ForgotPassword() {
  const { register, handleSubmit } = useForm();
  const apiInstance = useAxiosInstance();
  const navigate = useNavigate();

  const handleForgotPassword = async (formData) => {
    const email = (formData?.email || "").trim();
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
      toast.error("Please enter a valid email address.", {
        position: "top-right",
      });
      return;
    }
    try {
      const res = await sendResetPasswordEmail(apiInstance, formData.email);
      if (res.status === 200) {
        toast.success("Check your email for the reset link.", {
          position: "top-right",
        });
        setTimeout(() => {
          navigate("/");
        }, 5000);
      } else {
        toast.error(
          "User account not found or account verification is still pending!",
          {
            position: "top-right",
          },
        );
      }
    } catch (err) {
      toast.error("Failed to send reset email.", {
        position: "top-right",
      });
    }
  };

  return (
    <>
      <div className="flex items-center hero-bg">
        <Nav />
        <div className="flex items-center w-full max-w-xl mt-32">
          <div className="bg-[#363636] bg-opacity-90 shadow-lg rounded-lg p-8 w-full m-5">
            <h2 className="text-xl font-bold text-white mb-4 text-center">
              Forgot Password
            </h2>
            <form onSubmit={handleSubmit(handleForgotPassword)}>
              <div className="form-field mt-4 mb-4 text-lg ">
                <label htmlFor="email" className=" text-gray-700 text-xl mb-2">
                  Email
                </label>
                <input
                  type="email"
                  name="email"
                  {...register("email", { required: true })}
                  placeholder="Enter your email..."
                  className="mt-1 block w-full p-3 border border-gray-300 rounded-md"
                />
              </div>
              <button
                type="submit"
                className="bg-red-500 text-white rounded px-4 py-2 mt-6"
              >
                Reset Password
              </button>
            </form>
          </div>
        </div>
      </div>
    </>
  );
}
